import React from 'react';

import { BaseFieldRenderer } from './base';

export class ReceiptFieldRenderer extends BaseFieldRenderer {
  render() {
    const {
      eventId,
      fieldValue,
      event: { queue, transaction },
    } = this.props;

    // Mute rendering of the receipt for events that have transaction and queue information
    // as this duplicates the receipt data for the purpose of dynamically rendering it
    if (queue || transaction || typeof fieldValue !== 'string') {
      return null;
    }

    const textLines = fieldValue.split(/\n/);
    return (
      <div
        className="receipt"
        id={`receipt-text-${eventId}`}
        onContextMenu={this.onContextMenu}
        style={this.style()}
      >
        {textLines.map((line, key) => {
          return (
            <div className="pre" key={`pre-${key}`}>
              {line.length === 0 ? ' ' : line}
            </div>
          );
        })}
      </div>
    );
  }

  onContextMenu = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    this.props.onContextMenu(event);
  };
}
